import { Component, OnInit, ChangeDetectionStrategy, Input } from '@angular/core';

@Component({
  selector: 'sl-contact',
  templateUrl: './contact.component.html',
  styleUrls: [],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ContactComponent implements OnInit {
  @Input() contactTitle: boolean = true;
  constructor() { }
  public transBase = 'PRODUCTS.WARRANTY_CONFIRMATION.';

  ngOnInit(): void {
  }

}
